import { render, staticRenderFns } from "./ServiceVisitsBoard.vue?vue&type=template&id=e43a37e4&scoped=true&"
import script from "./ServiceVisitsBoard.vue?vue&type=script&lang=js&"
export * from "./ServiceVisitsBoard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceVisitsBoard.vue?vue&type=style&index=0&id=e43a37e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43a37e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
